import Input from "../../../../Core/Fields/Floating/Input";

const Costing = ({ errors }) => {


  return (
    <div className="row mb-2" >

      <div className="col-4">
        <div className="mb-3">
          <Input
            id="gstinUin"
            label="Operating Cost (INR)"
            style={{ height: "38px", border: errors?.gstinUin ? "1px solid red" : "" }}
            // value={formData.gstinUin}
            // onChange={(e) => handleChange('gstinUin', e.target.value)}
          />
        </div>
      </div>
      <div className="col-4">
        <div className="mb-3">
          <Input
            id="pan"
            label="Total Cost (INR)"
            style={{ height: "38px", border: errors?.pan ? "1px solid red" : "" }}
            // value={formData.pan}
            // onChange={(e) => handleChange('pan', e.target.value)}
          />
        </div>
      </div>
      
     
    </div>
  );
};

export default Costing;